import styled from 'styled-components';
// Components
import LangSwitcher from './LangSwitcher';

const LoginHeader = styled.div`
  text-align: center;
  min-height: 150px;
  border-bottom: 1px solid ${props => props.theme.color.border};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  @media all and (max-width: 576px) {
    min-height: 120px;
  }  
  .azmonica {
    height: 75px;
    @media all and (max-width: 576px) {
      height: 55px;      
    }
  }
  > div {
    position: absolute;
    right: 3em;
    top: 1em;
    @media all and (max-width: 768px) {
      right: 1em;
      top: 0.5em;
    }
  }    
`;

export default () => {
  return (
    <LoginHeader>
      {global.theme.logo}
      <LangSwitcher />
    </LoginHeader>
  );
};
